import { render, staticRenderFns } from "./LocationsConfig.vue?vue&type=template&id=51f73b84&scoped=true"
import script from "./LocationsConfig.vue?vue&type=script&lang=js"
export * from "./LocationsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f73b84",
  null
  
)

export default component.exports